import { Environment } from 'env/Environment'

export const env: Environment = {
  apiUrl: 'https://api-qa.asteriobid.com',
  loginUrl: 'https://api-qa.asteriobid.com/api/login',
  logoutUrl: 'https://api-qa.asteriobid.com/api/logout',
  debug: false,
  debugConnectFrame: false,
  production: false,
  partnerInstallation: false,
  stripeApiKey: 'pk_test_51Ro5ZK4ZbEgHcq4HkHLjjkmzRvY683mofGHTDc7I9OhJe30h4b1h4eLyKYdMo3TA6Ze7Io8AkRT3zG17OEAOlkZO003zl0j3qM',
  library: 'testing',
}
